import styled from 'styled-components';
import PropTypes from 'prop-types';
import { color, flex, flexDirection, display, alignItems, justifyContent } from 'styled-system';
import { cursor } from 'utils/styles/customStyledSystemProps';

const Modal = styled.div`
    ${color}
    ${flex}
    ${display}
    ${alignItems}
    ${justifyContent}
    ${flexDirection}
    ${cursor}
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
    z-index: 5;
    pointer-events: none;
    transition: opacity .3s ease;
    opacity: 0;
    
    ${props =>
			props.visible &&
			`
        opacity: 1;
        transition: opacity .3s ease 0s;
        pointer-events: all;
    `}

    > * {
        margin-bottom: 32px;   
    }

    a:hover {
        color: white;
    }
`;

Modal.propTypes = {
	visible: PropTypes.bool
};

Modal.defaultProps = {
	display: 'flex',
	flexDirection: 'column',
	bg: 'client.fontColor',
	visible: false
};

export default Modal;
